import { useEffect } from 'react';
import { confirmAdminAction } from '../utils/adminConfirm';

const MESSAGE = 'You have unsaved changes. Discard them?';

export const useUnsavedChanges = (dirty) => {
  useEffect(() => {
    const beforeUnload = (event) => {
      if (!dirty) return;
      event.preventDefault();
      event.returnValue = '';
    };
    window.addEventListener('beforeunload', beforeUnload);
    return () => window.removeEventListener('beforeunload', beforeUnload);
  }, [dirty]);

  return async () => !dirty || confirmAdminAction(MESSAGE, {
    title: 'Discard unsaved changes?',
    confirmLabel: 'Discard',
  });
};
